'use client';
import React, { useEffect, useState } from 'react';

export function StoryblokCountDown() {
  const [time, setTime] = useState({
    d: '00',
    h: '00',
    m: '00',
    s: '00',
  });

  const [expired, setExpired] = useState(false);

  function nextDec1Midnight() {
    const now = new Date();
    const thisYear = now.getFullYear();
    const thisDec1 = new Date(thisYear, 11, 1, 0, 0, 0, 0);
    return now < thisDec1 ? thisDec1 : new Date(thisYear + 1, 11, 1, 0, 0, 0, 0);
  }

  useEffect(() => {
    const deadline = nextDec1Midnight();

    function pad2(n: number) {
      return String(n).padStart(2, '0');
    }

    function tick() {
      const now = new Date();
      const diff = deadline.getTime() - now.getTime();

      if (diff <= 0) {
        setTime({ d: '00', h: '00', m: '00', s: '00' });
        setExpired(true);
        return;
      }

      const totalSec = Math.floor(diff / 1000);
      const days = Math.floor(totalSec / 86400);
      const hours = Math.floor((totalSec % 86400) / 3600);
      const mins = Math.floor((totalSec % 3600) / 60);
      const secs = totalSec % 60;

      setTime({
        d: String(days),
        h: pad2(hours),
        m: pad2(mins),
        s: pad2(secs),
      });
    }

    tick();
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="font-sans text-slate-900">
      <section
        role="status"
        aria-live="polite"
        className="
          w-full 
          border-0
          bg-[#f3f8f8]
          px-4
          py-14
          shadow-[0_2px_4px_0_#00000008,0_8px_8px_0_#00000008]
          sm:py-8
          md:py-14
        "
      >
        {/* Eyebrow */}
        <p className="mb-5 text-center font-semibold text-slate-700">{expired ? 'Offerta scaduta.' : 'Offerta valida ancora per'}</p>

        {/* Timer */}
        <div
          className="
            mb-5 flex items-baseline 
            justify-center
            gap-[clamp(0.65rem,1vw,1rem)]
          "
          role="timer"
          aria-label="Tempo rimanente"
        >
          <span className="text-[clamp(2rem,3vw+1.2rem,4rem)] font-extrabold tabular-nums leading-none">{time.d}</span>
          <span className="text-[clamp(1.6rem,2.4vw+0.6rem,3rem)] font-bold opacity-55">:</span>
          <span className="text-[clamp(2rem,3vw+1.2rem,4rem)] font-extrabold tabular-nums leading-none">{time.h}</span>
          <span className="text-[clamp(1.6rem,2.4vw+0.6rem,3rem)] font-bold opacity-55">:</span>
          <span className="text-[clamp(2rem,3vw+1.2rem,4rem)] font-extrabold tabular-nums leading-none">{time.m}</span>
          <span className="text-[clamp(1.6rem,2.4vw+0.6rem,3rem)] font-bold opacity-55">:</span>
          <span className="text-[clamp(2rem,3vw+1.2rem,4rem)] font-extrabold tabular-nums leading-none">{time.s}</span>
        </div>

        {/* Labels */}
        <div
          aria-hidden="true"
          className="
            mt-1 flex 
            justify-center
            gap-[clamp(1.8rem,3.2vw,3rem)]
            text-[0.9rem]
            text-slate-700
            sm:text-[0.8rem]
          "
        >
          <span className="w-[4.5ch] text-center">Giorni</span>
          <span className="w-[4.5ch] text-center">Ore</span>
          <span className="w-[4.5ch] text-center">Minuti</span>
          <span className="w-[4.5ch] text-center">Secondi</span>
        </div>

        {/* CTA */}
        <div className="mt-4 flex justify-center">
          <a
            href="https://form.typeform.com/to/DzG3WT3n"
            aria-disabled={expired}
            className={`
              inline-flex items-center justify-center
              rounded-xl border
              border-black/5
              bg-teal-700
              px-5 py-3
              font-bold
              text-white
              transition
              ${expired ? 'pointer-events-none cursor-not-allowed opacity-60' : 'cursor-pointer'}
            `}
          >
            Blocca l&apos;offerta
          </a>
        </div>
      </section>
    </div>
  );
}
